export default {
    namespaced: true,

    state: {
        myFilialId: null,
        myUid: null
    },

    mutations: {
        setMyFilialId(state, id) {
            state.myFilialId = id;
        },
        setMyUid(state, id) {
            state.myUid = id;
        },
    }
};
